import { Clickable, Size } from '../../types';
import { IconName } from '../icons/icon';

export interface DropdownProps {
  className?: string;
  id?: string;
  listOptions?: DropdownListItemProps[];
  iconSize?: Size;
}

export interface DropdownListItemProps extends Clickable {
  className?: string;
  id?: string;
  text: JSX.Element | string;
  icon?: IconName;
  size?: Size;
}
